import {
  View,
  Text,
  Animated,
  TouchableOpacity,
  StyleSheet,
  Platform,
} from "react-native";
import React, { useRef } from "react";
import { createStackNavigator } from "@react-navigation/stack";

import HomeNavigator from "./HomeNavigator";
import Header from "../../components/header/Header";
import Cookies from "universal-cookie";
import LoginModal from "../../components/modals/LoginModal";
import { useDispatch, useSelector } from "react-redux";
import ConsultationNavigator from "./ConsultationNavigator";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import HomeIcon from "../../assets/svg/HomeIcon";
import HistoryBottomIcon from "../../assets/svg/HistoryBottomIcon";
import ConsultationIcon from "../../assets/svg/ConsultationIcon";
import LearnIcon from "../../assets/svg/LearnIcon";
import MyText from "../../components/custom/MyText";
import { primary, white } from "../../colors";
import translate from "../../functions/translate";
import LearnNavigator from "./TutorialNavigator";
import TestNavigator from "./TestNavigator";
import SelectLanguageModal from "../../components/modals/SelectLanguageModal";
import { getStringData } from "../../functions/db/db";
import { setLanguageModal } from "../../redux/modal/modalAction";
import PushNotification from "../PushNotification";
import Support from "../main/Support";
import { Toast } from "react-native-toast-message/lib/src/Toast";
import NoMoneyModal from "../../components/modals/NoMoneyModal";
const cookies = new Cookies();
const Stack = createStackNavigator();
const BottomNavigator = createBottomTabNavigator();

const TabButton = (props) => {
  const main = useSelector((store) => store.main);
  const { Icon } = props.item;
  const selected = props.accessibilityState.selected;
  const animation = useRef(new Animated.Value(0)).current;

  if (selected) {
    Animated.spring(animation, {
      toValue: 1,
      useNativeDriver: true,
    }).start();
  } else {
    Animated.timing(animation, {
      toValue: 0,
      useNativeDriver: true,
      duration: 600,
    }).start();
  }

  return (
    <TouchableOpacity
      style={[styles.container]}
      onPress={() =>
        !main.rtl && props.item.name === "Support"
          ? main.token !== null
            ? props.onPress()
            : Toast.show({
                type: "error",
                text1: translate("please login first"),
              })
          : props.onPress()
      }
      activeOpacity={1}
    >
      <Animated.View style={[styles.button, { backgroundColor: primary }]}>
        <Icon color={white} />

        <View style={[{ overflow: "visible" }]}>
          <MyText
            style={{
              color: white,
              fontSize: 12,
            }}
          >
            {props.item.actualName}
          </MyText>
        </View>
      </Animated.View>
      <Animated.View
        style={[styles.button, { backgroundColor: white, opacity: animation }]}
      >
        <Icon color={primary} />

        <Animated.View style={[{ overflow: "visible" }]}>
          <MyText
            style={{
              color: primary,
              fontSize: 12,
            }}
          >
            {props.item.actualName}
          </MyText>
        </Animated.View>
      </Animated.View>
    </TouchableOpacity>
  );
};

export default function Main() {
  const dispatch = useDispatch();
  if (Platform.OS === "web") {
    const lang = cookies.get("language");
    if (lang === undefined || lang === null) {
      dispatch(setLanguageModal());
    }
  }
  getStringData("languageSet").then((data) => {
    if (data === null) {
      dispatch(setLanguageModal());
    }
  });
  const main = useSelector((store) => store.main);
  const header = useSelector((store) => store.header);
  const tabArr = [
    {
      name: "HomeNavigator",
      actualName: translate("home"),
      component: HomeNavigator,
      Icon: (props) => (
        <HomeIcon
          name="home"
          size={24}
          style={{ transform: [{ scale: 0.8 }] }}
          {...props}
        />
      ),
    },
    {
      name: "TestNavigator",
      actualName: translate("test"),
      component: TestNavigator,
      Icon: (props) => (
        <HistoryBottomIcon
          name="chat-question-outline"
          size={24}
          style={{ transform: [{ scale: 0.8 }] }}
          {...props}
        />
      ),
    },
    {
      name: main.rtl ? "ConsultationNavigator" : "Support",
      actualName: translate("doctors"),
      component: main.rtl ? ConsultationNavigator : Support,
      Icon: (props) => (
        <ConsultationIcon
          name="shop"
          size={24}
          style={{ transform: [{ scale: 0.8 }] }}
          {...props}
        />
      ),
    },
    {
      name: "LearnNavigator",
      actualName: translate("learn"),
      component: LearnNavigator,
      Icon: (props) => (
        <LearnIcon
          name="doctor"
          size={22}
          style={{ transform: [{ scale: 0.8 }] }}
          {...props}
        />
      ),
    },
  ];
  return (
    <View
      style={{ flex: 1, backgroundColor: "#fff" }}
      dir={main.rtl ? "rtl" : "ltr"}
    >
      <Header />
      <SelectLanguageModal />
      <NoMoneyModal />
      <BottomNavigator.Navigator
        initialRouteName="HomeNavigator"
        screenOptions={{
          animationEnabled: true,
          tabBarHideOnKeyboard: true,
          headerShown: false,
          tabBarStyle: {
            height: 75,
            position: "absolute",
            bottom: 16,
            right: 6,
            left: 6,
            borderRadius: 25,
            overflow: "hidden",
            backgroundColor: primary,
            display: header.bottomNavigation ? "flex" : "none",
          },
        }}
      >
        
        {tabArr.map((tab, index) => (
          <BottomNavigator.Screen
            key={index}
            name={tab.name}
            component={tab.component}
            options={{
              tabBarButton: (props) => <TabButton {...props} item={tab} />,
            }}
          />
        ))}
      </BottomNavigator.Navigator>

      <PushNotification />
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    height: 75,
    overflow: "visible",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "nowrap",
  },
  button: {
    position: "absolute",
    width: 70,
    height: 70,

    backgroundColor: "black",
    borderRadius: 40,
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
});
